export const REGULAR_COLORS = [
  'BLUE',
  'GREEN',
  'BLACK',
  'PINK',
  'PURPLE',
  'WHITE',
  'RED',
  'BEIGE',
  'GREY',
  'ORANGE',
  'YELLOW',
  'BROWN',
] as const;

export const SEO_COLORS = [
  'MULTI',
  'BLUE',
  'DUSTY_BLUE',
  'ROYAL_BLUE',
  'NAVY',
  'BLACK',
  'RED',
  'BURGUNDY',
  'WHITE',
  'PURPLE',
  'LAVENDER',
  'PLUM',
  'PINK',
  'ROSE',
  'DUSTY_ROSE',
  'CORAL',
  'PEACH',
  'GREEN',
  'EMERALD_GREEN',
  'TEAL',
  'ORANGE',
  'YELLOW',
  'GREY',
  'BROWN',
  'BEIGE',
  // 'GOLD',
  // 'SILVER',
  // 'ROSE_GOLD',
] as const;

export type SeoColor = typeof SEO_COLORS[number];

export const isSeoColorType = (type?: string): type is SeoColor => {
  if (!type) return false;
  return (SEO_COLORS as Readonly<string[]>).includes(type);
};
